import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';


@Component({
  selector: 'app-financial-analysis',
  imports: [
    RouterOutlet
  ],
  template: `
    <router-outlet/>
  `
})
export default class FinancialAnalysisComponent {}
